import Cookies from "js-cookie";
import { encryptValue } from "./app-utils";

/** Persist or clear JHID profile picture URL from auth exchange/refresh (ACME-1757). */
export const setPictureSessionCookie = (picture?: string | null) => {
  const url = typeof picture === "string" ? picture.trim() : "";
  if (url) {
    Cookies.set("picture", url, { secure: true });
  } else {
    Cookies.remove("picture");
  }
};

export const setUserSessionCookies = (userData: {
  token: {
    token: string;
    refreshToken: string;
    expiry: string;
    tokenUserName: string;
    picture?: string | null;
  };
  userId: string;
  role: string;
  userType: string;
  fullName: string;
  businessUnit: string;
  email: string;
}) => {
  const expireDate = new Date(userData.token.expiry);
  const todaysDate = new Date();
  const expiryTimeMillisec = expireDate.getTime() - todaysDate.getTime();

  Cookies.set("timeOut", expiryTimeMillisec.toString(), { secure: true });
  Cookies.set("expiryDateTime", userData.token.expiry, { secure: true });
  Cookies.set("token", userData.token.token, { secure: true });
  Cookies.set("refreshToken", userData.token.refreshToken, { secure: true });
  Cookies.set("tokenUserName", encryptValue(userData.token.tokenUserName), { secure: true });
  Cookies.set("userId", encryptValue(userData.userId), { secure: true });
  Cookies.set("userRole", encryptValue(userData.role), { secure: true });
  Cookies.set("userType", encryptValue(userData.userType), { secure: true });
  Cookies.set("userName", encryptValue(userData.fullName), { secure: true });
  // Enterprise Admins are not scoped to a single business unit. Some upstream
  // responses still send a stale/default `businessUnit` for EA accounts, which
  // would then surface in the UI (e.g. sidebar) and in any code that filters by
  // BU. Force-clear the cookie for EAs so the rest of the app sees "no BU".
  if (/enterpriseadmin/i.test(userData.userType || "")) {
    Cookies.remove("businessUnit");
  } else {
    Cookies.set("businessUnit", userData.businessUnit ?? "", { secure: true });
  }
  Cookies.set("email", encryptValue(userData.email), { secure: true });
  setPictureSessionCookie(userData.token.picture);
  // Replace any expired stamp before status flips to loggedIn, so another tab
  // cannot observe a new session that still looks idle-expired.
  Cookies.set("lastActiveTime", new Date().toISOString(), { secure: true });
  Cookies.set("status", "loggedIn", { secure: true });
};
